export default class QuoteProductPriceComponentViewModel {
  constructor(item) {
    if (item) {
      this.type = item.type;
      this.name = item.name;
      this.correlationId = item.correlationId;
      this.dNetPrice = item.dNetPrice;
      this.msrp = item.msrp;
      this.originalDNetPrice = item.originalDNetPrice;
    }
  }
}
